import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import { AllInclusive } from '@material-ui/icons';
import React from 'react';
import SignalRConnector, { signalRDetail } from 'src/coreservices/SignalRConnector';
import { InformationModal } from 'src/formcontrols/Modals/InformationModal/InformationModal';
import { writeAIEvent } from 'src/utils/AppInsight';
import { GetLocalStateProfile } from 'src/comps/UserProfile/UserProfile';

const styles = (theme: any) => ({
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 32,
    height: 18,
    marginTop: -9,
    marginLeft: -18,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 15,
    height: 15,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});
let useSignalR: boolean;
let onDemandSignalR = false;
interface ISignalRProps {
  switched: boolean;
  position: string;
  classes: any;
  isOpenSignalRDetail: boolean;
  onDemandSignalR: boolean;
  updateUseSignalR: any;
}

interface ISignalRState {
  switched: boolean;
  isOpenSignalRDetail: boolean;
}
const divStyle = {
  height: '30px',
};
class UseSignalR extends React.Component<ISignalRProps, ISignalRState> {
  constructor(props: any) {
    super(props);
    this.state = {
      switched: this.props.switched,
      isOpenSignalRDetail: false,
    };
    this.openSignalRDetail = this.openSignalRDetail.bind(this);
    this.closeSignalRDetail = this.closeSignalRDetail.bind(this);
  }

  componentDidMount(){
    const userProfile = GetLocalStateProfile();
    if (!onDemandSignalR) {
      if (userProfile.DefaultUseSignalR) {
        this.setState({ switched: true });
        useSignalR = true;
      } else {
        this.setState({ switched: false });
        useSignalR = false;
      }
    }
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState({ isOpenSignalRDetail: nextProps.isOpenSignalRDetail });
    const userProfile = GetLocalStateProfile();
    if (nextProps.onSaveUseSignalR) {
      onDemandSignalR = false;
      this.props.updateUseSignalR();
    }
    if (!onDemandSignalR) {
      if (userProfile.DefaultUseSignalR) {
        this.setState({ switched: true });
        useSignalR = true;
      } else {
        this.setState({ switched: false });
        useSignalR = false;
      }
    }
  }

  handleChange = (_name: any) => async (event: any) => {
    onDemandSignalR = true;
    this.setState({ switched: event.target.checked });
    useSignalR = event.target.checked;
    const signalRConnector = new SignalRConnector({ isUseSignalR: false });
    if (useSignalR) {
      writeAIEvent(`Use SignalR - True`);
      await signalRConnector.connectToSignalR();
    } else {
      writeAIEvent(`Use SignalR - False`);
      signalRConnector.disconnectSignalR();
    }
    signalRConnector.updateUseSignalR(useSignalR);
    const imgSignalR = document.getElementsByClassName('signalRClass') as HTMLCollectionOf<HTMLElement>;
    if (imgSignalR[0] !== null && imgSignalR[0] !== undefined) {
      imgSignalR[0].style.display = useSignalR ? 'block' : 'none';
    }
  };
  openSignalRDetail() {
    this.setState({ isOpenSignalRDetail: true });
  }
  closeSignalRDetail() {
    this.setState({ isOpenSignalRDetail: false });
  }

  render() {
    const { classes } = this.props;

    return this.props.position === 'app' ? (
      <div style={{ marginTop: '5px' }}>
        <InformationModal
          isLoading={false}
          isModalOpen={this.state.isOpenSignalRDetail}
          modalHeader={'SignalR Connection Information'}
          onCloseModal={this.closeSignalRDetail}
        >
          <table>
            <tbody>
              <div style={divStyle}>SignalR Client Id : {signalRDetail ? signalRDetail.SignalrClientId : ''} </div>
              <div style={divStyle}>Transport Type : {signalRDetail ? signalRDetail.TransportType : ''} </div>
              <div style={divStyle}>Elapsed Time : {signalRDetail ? signalRDetail.ElapsedTime : ''} </div>
              <div style={divStyle}>SignalR Status : {signalRDetail ? 'Connected' : 'Disconnected'} </div>
            </tbody>
          </table>
        </InformationModal>
        <Tooltip title="Connected">
          <AllInclusive onClick={this.openSignalRDetail} className="signalRClass" style={{ display: 'none' }} />
        </Tooltip>
      </div>
    ) : (
      <Switch
        classes={{
          switchBase: classes.iOSSwitchBase,
          bar: classes.iOSBar,
          icon: classes.iOSIcon,
          iconChecked: classes.iOSIconChecked,
          checked: classes.iOSChecked,
        }}
        disableRipple
        checked={useSignalR}
        onChange={this.handleChange('checkedB')}
        value="checkedB"
      />
    );
  }
}

export default withStyles(styles)(UseSignalR);
export { useSignalR };
